import React from 'react'
import style from './TextInput.module.css'

const TextInput = ({ name, value, title, type = "text", onChange, placeholder, id, className }) => {
  return (
    <div className={`${className || ''} ${style.cover}`}>
      <label htmlFor={id}>{title}</label>
      <input 
        name={name}
        value={value}
        id={id}
        placeholder={placeholder}
        onChange={onChange ? (event) => onChange(event) : undefined}
        className={style.textInput}
        type={type}
      />
    </div>
  );
}

export default TextInput;
